import { RichText } from "@atlassiansox/bxp-content-framework";

import { AnalyticsAttributesProvider } from "../../components";
import { UiCalloutModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import {
    Callout,
    CalloutMedia,
    CalloutIcon,
    CalloutText,
    CalloutHeading
} from "./UiCallout.styles";

export type UiCalloutProps = {
    model: UiCalloutModel;
};

const UiCallout = ({ model }: UiCalloutProps) => {
    const {
        type,
        content: { entryTitle, media, mediaOnRight, heading, text, icon, theme }
    } = model;
    return (
        <AnalyticsAttributesProvider
            value={{
                eventComponent: type,
                labelEnglish: entryTitle,
                parentLabel: heading
            }}
        >
            <Callout mediaOnRight={mediaOnRight}>
                <CalloutMedia>{renderViewModel(media)}</CalloutMedia>
                <CalloutText>
                    <CalloutHeading>
                        {icon && (
                            <CalloutIcon $color={theme}>
                                {renderViewModel(icon)}
                            </CalloutIcon>
                        )}
                        <h3>{heading}</h3>
                    </CalloutHeading>
                    <RichText document={text} />
                </CalloutText>
            </Callout>
        </AnalyticsAttributesProvider>
    );
};

export default UiCallout;
